import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';

type GetCurrentReleaseVersion = {
  assembly: string;
  version: string;
};

export function useCurrentReleaseVersion() {
  const { getAccessToken } = useAuth();

  const getCurrentReleaseVersion = async (): Promise<GetCurrentReleaseVersion | null> => {
    const client = createApiClient(getAccessToken);
    const { data } = await client.GET('/api/release');

    return data ? (data as GetCurrentReleaseVersion) : null;
  };

  const query = useQuery({
    queryKey: ['currentReleaseVersion'],
    queryFn: async () => {
      try {
        return await getCurrentReleaseVersion();
      } catch (err) {
        if (err instanceof Error) {
          throw err;
        }

        throw new Error(err ? String(err) : 'Unknown error occurred');
      }
    },
    retry: false,
  });

  const { data, isLoading, error, refetch, isRefetching } = query;

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
}
